import { createSlice } from "@reduxjs/toolkit";
import { getFundingSource } from "../actions";

interface FundingSource {
    name: string;
    fundingProvider: number;
    vendorID: number;
    address: {
        street1: string;
        street2: string;
        city: string;
        state: string
        zipCode: number;
        country: string;
    },
    title: string;
    firstName: string;
    lastName: string;
    phoneNumber: number;
    ext: number;
    faxNumber: number;
    payer: string;
    payerType: string;
    email: string;
}

interface FundingSourceState {
    fundingSource: FundingSource[] | any;
    isLoading: boolean;
}

const initialState: FundingSourceState = {
    fundingSource: [],
    isLoading: false,
};


export const fundingSourceInitialSlice = createSlice({
    name: 'fundingSource',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getFundingSource.fulfilled, (state, action) => {
                state.fundingSource = action.payload;
                state.isLoading = false;
            })
            .addCase(getFundingSource.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(getFundingSource.rejected, (state, action) => {
                state.isLoading = false
            })
    },
})

export default fundingSourceInitialSlice.reducer